import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#FFF"
    }, [
      _createElementVNode("circle", {
        cx: "17.5",
        cy: "17.5",
        r: "17"
      }),
      _createElementVNode("path", { d: "M15.5 13v9m4-9v9" })
    ], -1)
  ]))]))
}
export default { render: render }